import React, { Fragment } from 'react';
import { prop } from 'ramda';

import http from 'api/http';
import { manufacturerAPI } from 'api/requests';

import { getIsBoatManufacturer, getIsTrailerManufacturer } from 'helpers';

const getShouldLoadInspectorContacts = user => getIsBoatManufacturer(user) || getIsTrailerManufacturer(user);
//const getShouldLoadInspectorContacts = user => true;


class Contacts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      engineeringContacts: null,
      inspectionContacts: null,
      isEngineeringContactsLoading: true,
      isInspectionContactsLoading: true,
    };
  }

  componentDidMount() {
    const { user } = this.props;

    //const code = user.selectedManufacturer.code;
    const code = user.getManufacturerCode();

    const shouldLoadInspectorContacts = getShouldLoadInspectorContacts(user);

    http
      .get(manufacturerAPI.getEngineeringContacts(code))
      .then(response =>
        this.setState({
          isEngineeringContactsLoading: false,
          engineeringContacts: response.data,
        })
      )
      .catch(() => this.setState({ isEngineeringContactsLoading: false, engineeringContacts: null }))
      .finally(() => {
        if (shouldLoadInspectorContacts) {
          http
            .get(manufacturerAPI.getInspectorContacts(code))
            .then(response =>
              this.setState({
                isInspectionContactsLoading: false,
                inspectionContacts: response.data,
              })
            )
            .catch(() => this.setState({ isInspectionContactsLoading: false, inspectionContacts: null }));
        } else {
          this.setState({ isInspectionContactsLoading: false })
        }
      });
  }

  render() {
    const { user } = this.props;

    const { engineeringContacts, inspectionContacts, isEngineeringContactsLoading, isInspectionContactsLoading }
      = this.state;

    const shouldLoadInspectorContacts = getShouldLoadInspectorContacts(user);

    return (
      <Fragment>
        <section className='scene_section _padding_top_15 _padding_bottom_20'>
          <header>Engineering Standards Contact</header>
          <div className='_margin_top_10'>
            {isEngineeringContactsLoading
              ? 'Loading...'
              : !prop('length', engineeringContacts)
                ? 'No Contacts'
                : engineeringContacts.map(({ firstName, lastName, email }) => (
                  <div key={email} className="engineering_contacts_item"><b>{firstName} {lastName}</b> - {email}</div>
                ))}
          </div>
        </section>
        {shouldLoadInspectorContacts && <section className='scene_section _padding_top_15 _padding_bottom_20'>
          <header>Inspector Information</header>
          <div className='_margin_top_10'>
            {isInspectionContactsLoading
              ? 'Loading...'
              : !prop('length', inspectionContacts)
                ? 'No Contacts'
                : inspectionContacts.map(({ company, firstName, lastName, email }) => (
                  <div key={email} className="engineering_contacts_item"><b>{firstName} {lastName} ({company.name})</b> - {email}</div>
                ))}
          </div>
        </section>}
      </Fragment>
    );
  }
}

export default Contacts;



// WEBPACK FOOTER //
// ./src/app/Scenes/SummaryScene/Contacts.jsx